module.exports = __webpack_public_path__ + "img/ketchup-icon.12cf8415.png";